module.exports = __webpack_public_path__ + "static/img/about3.57c8f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/about3.jpg
// module id = 72wc
// module chunks = 3